import * as actions from '../../actions/actionTypes';

const initialState = false;

export default function fetching(state = initialState, action) {
  switch (action.type) {
    case actions.SET_PUSH_ALARM_FETCHING:
      return true;
    case actions.SET_PUSH_ALARM:
      return false;
    default:
      return state;
  }
}
